import React, { useState } from "react";
import { Avatar, Icon } from "shared";
import { fromNow } from "utils/DateUtils";
import "./index.scss";
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";

type PotentialZoneProps = {
  zone: any;
  toggleSitePlanningCommentUI: () => void;
  editPlanningPolygon: () => void;
};

const PotentialZone = ({
  zone,
  editPlanningPolygon,
  toggleSitePlanningCommentUI,
}: PotentialZoneProps) => {
  const [isOpenMenu, setOpenMenu] = useState(false);
  if (!zone) return null;
  const { properties } = zone || {};
  const {
    created_on,
    description,
    title,
    user,
    site_planning_zone_comment_count,
    is_active,
  } = properties || {};
  const { first_name, last_name, avatar } = user || {};
  const toggle = () => setOpenMenu(!isOpenMenu);
  return (
    <div className="potential-zone__container">
      <div className="potential-zone__author">
        <Avatar name={`${first_name} ${last_name}`} value="1" />
        <div className="potential-zone__col" style={{ flex: 1 }}>
          <span className="potential-zone__author-name">{`${first_name} ${last_name}`}</span>
          <span className="potential-zone__created-at">
            {fromNow(created_on)}
          </span>
        </div>
        <Dropdown isOpen={isOpenMenu} toggle={toggle}>
          <DropdownToggle className="potential-zone__more">
            <Icon
              name="more_vert"
              fill={false}
              size="medium"
              customClassName="potential-zone__menu"
            />
          </DropdownToggle>
          <DropdownMenu right>
            <DropdownItem onClick={editPlanningPolygon}>Chỉnh sửa</DropdownItem>
            <DropdownItem
              className="menu-comment"
              onClick={toggleSitePlanningCommentUI}
            >
              Nhận xét
              {site_planning_zone_comment_count ? (
                <div className="comment-count">
                  <span> {site_planning_zone_comment_count}</span>
                </div>
              ) : (
                ""
              )}
            </DropdownItem>
          </DropdownMenu>
        </Dropdown>
      </div>
      <div className="potential-zone__col potential-zone__body">
        <span className="potential-zone__title">{title}</span>
        <span className="potential-zone__description">
          {description || "-"}
        </span>
      </div>
    </div>
  );
};

export default PotentialZone;
